import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=d488333a&scoped=true&"
import script from "./ConversationList.vue?vue&type=script&lang=js&"
export * from "./ConversationList.vue?vue&type=script&lang=js&"
import style0 from "./ConversationList.vue?vue&type=style&index=0&id=d488333a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d488333a",
  null
  
)

export default component.exports